import { Component, OnInit, Input, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { KeywordSearchService } from './services/keywordsearch.service';
import { KeywordSearchConfigModel } from './models/keywordsearch-config.model';
import { environment } from '@covestro/config-environments/environment';

import {
	IFilterModel,
	IFilterKeywordsearchConfigModel,
	ITooltipModel,
} from '@covestro/models';

import { TerrificOnInit } from '@covestro/pattern-library/dist/ng/aot/src/lib/helpers/angular-terrific-on-init/terrific-on-init';

import { TechnicalPropertyPopupComponent } from '@covestro/pattern-library/dist/ng/aot/src/lib/molecules/technical-property-popup/ng/technical-property-popup.component';
import { KeywordSearchSearchConfigModel } from './models/keywordsearch-search-config.model';

@Component({
	selector: 'keywordsearch-root',
	templateUrl: './keywordsearch.component.html',
})

export class KeywordSearchComponent extends TerrificOnInit {
	
	@ViewChild('technicalPropertyPopupComponent')
	technicalPropertyPopupComponent: TechnicalPropertyPopupComponent;

	@Input()
	tooltip: ITooltipModel;

	static readonly MARKET_SWITCH_COOKIE = 'cov_market';
	static readonly MARKET_SWITCH_TOOLTIP_COOKIE = 'cov_market_tooltip';

	environment: any = environment;

	private _config: KeywordSearchSearchConfigModel;
	private _searchText: string;

	/**
	 * Contains all already loaded brands
	 */
	
	private _showSpinner = true;
	private _totalCount = 0;
	private _currentCount = 0;
	private _searchLoading = true;
	private _appInitialized = false;
	private _errorHasOccured: boolean = false;
	private _regionFilter: IFilterModel;
	private _keywordTypeFilter: IFilterModel;
	private _technologiesFilter: IFilterModel;
	private _materialAttributeFilter: IFilterModel;
	private _industryApplicationFilter: IFilterModel;
	private _terrificHasBootstrapped: boolean = false;

	private _lastUrlParams: {
		query?: string;
		pageSize?: string;
	};

	constructor(
		private keywordSearchService: KeywordSearchService,
		private route: ActivatedRoute,
		private router: Router,
		private location: PlatformLocation,
		protected renderer: Renderer2,
	) {
		super(renderer);
	}

	ngOnInit() {
		this.validateAndSetConfigurationItems();

		this.location.onPopState(() => {
			this._showSpinner = true;
			this._searchLoading = true;
		});

		super.ngOnInit();
	}

	onTerrificBootstrap(): void {
		this._terrificHasBootstrapped = true;
	}

	get appInitialized(): boolean {
		return this._appInitialized;
	}

	showLoadMoreButton(): boolean {
		return this._currentCount < this._totalCount;
	}

	showResults(): boolean {
		return this._totalCount > 0;
	}

	isAnyFilterOpen() {
		return (
			this._regionFilter.isOpen ||
			this._industryApplicationFilter.isOpen ||
			this._keywordTypeFilter.isOpen ||
			this._technologiesFilter.isOpen ||
			this._materialAttributeFilter.isOpen
		);
	}

	onSearchChanges(val: string): void {
		this._searchText = val;
	}

	private validateAndSetConfigurationItems() {
		this.keywordSearchService.getConfig().subscribe((config) => {
			if (!config) {
				return;
			}
			this._config = config;
		});
		this._appInitialized = true;
	}

	get terrificHasBootstrapped(): boolean {
		return this._terrificHasBootstrapped;
	}

	get autosuggestSearchConfig(): IFilterKeywordsearchConfigModel {
		return this._config.downloadTableFilterKeywordsData;
	}

	get keySearchConfig(): IFilterKeywordsearchConfigModel {
		return this._config.downloadTableFilterKeywordsData;
	}

	get searchText(): string {
		return this._searchText;
	}	

	get searchButtonText(): string {
		return this._config.downloadTableFilterKeywordsData.searchButtonText;
	}

	get errorHasOccured(): boolean {
		return this._errorHasOccured;
	}
}
